import { render, staticRenderFns } from "./ItemsAdv.vue?vue&type=template&id=3cd56393&scoped=true&lang=pug&"
import script from "./ItemsAdv.vue?vue&type=script&lang=ts&"
export * from "./ItemsAdv.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsAdv.vue?vue&type=style&index=0&id=3cd56393&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd56393",
  null
  
)

export default component.exports